import React from 'react'
import './NoteLoader.scss'

export const NoteLoader = () => (
  <div className='Note-Loader'>
    <span className='Note-Loader__line' />
    <span className='Note-Loader__line' />
    <span className='Note-Loader__line' />
    <span className='Note-Loader__line' />
    <span className='Note-Loader__line' />
    <span className='Note-Loader__note fa-solid fa-music' />
  </div>
)
